<template>
  <footer v-if="isDark" class="footer-dark">
    <div>
      <p class="text-muted my-2">Produced by Team Amabie</p>
    </div>
    <button
      type="button"
      class="btn btn-outline-success"
      v-on:click="changeTheme"
      v-if="this.$store.getters.user.uid"
    >
      テーマを変える
    </button>
  </footer>
  <footer v-else class="footer-light">
    <div>
      <p class="text-muted my-2">Produced by Team Amabie</p>
    </div>
    <button
      type="button"
      class="btn btn-outline-success"
      v-on:click="changeTheme"
      v-if="this.$store.getters.user.uid"
    >
      テーマを変える
    </button>
  </footer>
</template>

<script>
export default {
  data: function() {
    return {
      isDark: this.$store.getters.user.isDark
    };
  },
  methods: {
    changeTheme() {
      //booleanを反転
      this.isDark = !this.isDark;
      this.$store.dispatch("updateUserData", { isDark: this.isDark });
      window.setTimeout("location.reload(true)", 1000);
    }
  }
};
</script>

<style lang="css">
/* Sticky footer styles
-------------------------------------------------- */
html {
  position: relative;
  min-height: 100%;
}

footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  /* Set the fixed height of the footer here */
  height: 100px;
}

.footer-light {
  background-color: #f5f5f5;
}

.footer-dark {
  background-color: #343a40;
}

/* Custom page CSS
-------------------------------------------------- */
/* Not required for template or sticky footer method. */
</style>
